import Pagination from '@/util/pagination'

export default function () {
  return {
    users: [],
    pagination: new Pagination(),
    invalidatedSessionsSuccess: false,
    filters: {
      name: '',
      email: '',
      roles: '',
    },
    availableRoles: [
      {
        label: 'Administrador',
        name: 'ROLE_ADMIN',
      },
      {
        label: 'Professor',
        name: 'ROLE_TEACHER',
      },
      {
        label: 'Aluno',
        name: 'ROLE_STUDENT',
      },
    ],
  }
}
